(function (){
    'use strict';
    angular.module('Services').service('AffiliatePromoCodeTableService', AffiliatePromoCodeTableService);
    AffiliatePromoCodeTableService.$inject = [
        '$filter',
        '$uibModal',
        'TableLiteFactory',
        '$rootScope',
        '$routeParams',
        'AffiliateService',
        'toastr',
        'ConfirmationModalFactory'
    ];

    function AffiliatePromoCodeTableService(
        $filter,
        $uibModal,
        TableLiteFactory,
        $rootScope,
        $routeParams,
        AffiliateService,
        toastr,
        ConfirmationModalFactory
    ){
        return function (){
            const role = $rootScope.GlobalProfile.permissionGroup.roles.find(permission => permission.code ===  'ROLE_COMPANY_ADMIN' || permission.code ==='ROLE_ADMIN') ? true : false;

            const deleteConfirmationModal = new ConfirmationModalFactory({}, {
                message: 'You are about to delete this promo code.',
                code: 'messages.warning.deleteAdminAccount.CODE'
            });

            const statusConfirmationModal = new ConfirmationModalFactory({}, {
                message: 'You are about to Deactive this promo code.',
                code: 'messages.warning.deleteAdminAccount.CODE'
            });

            const promoButton={
                class: 'btn-success',
                label: 'Add Promo code',
                tooltip: 'Add Promo code',
                onClick: function () {
                    showPromoCodeDetailsModal(vm.id);
                }
            }

            const vm = this
            vm.id = $routeParams.id;
            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtract: true,

                },
                optionAddOns:{
                    buttons: []
                },
                headers:[
                    {
                        label: 'Promo Code',
                        viewName: 'code',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Description',
                        viewName: 'description',
                       
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: '$ Discount',
                        viewName: 'discountValueCurrency',
                        filterName:'discountValue',
                       
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: '% Discount',
                        viewName: 'discountPercent',
                       
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    // {
                    //     label: 'Duration',
                    //     viewName: 'duration',
                    //     filter: {
                    //         type: 'text',
                    //         placeholder: 'Search',
                    //         onSubmit: header => {
                    //             sendRequest(evaluateFilter(header));
                    //         }
                    //     },
                    //     headerFn: function(){
                    //         sort(this.filterName);
                    //     }
                    // },
                    {
                        label: 'Status',
                        viewName: 'status'
                    },
                    {
                        label:'Action',
                        viewName:'actions'
                    }
                ],
                data:[]
            }

            if(role){
                tableData.optionAddOns.buttons.push(promoButton)
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getAllPromoCode,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err.message,'Code: '+err.code);
                    },
                    defaultFilters : {
                        companyMarketingId:vm.id,
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    } 
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.code = item.code;
                    item.description = item.description;

                    item.discountValueCurrency =  $filter('bbaCurrency')(item.discountValue, '');
                    item.discountPercent = item.discountPercent;

                    item.duration = durationFormat(item) 
                    item.status = {
                        type: 'status',
                        status: item.active,
                        label: item.active ? 'Active' : 'Inactive'
                    };
                    item.actions = {
                        type: 'button',
                        buttons: [
                            {
                                text: 'Assign',
                                class: 'btn btn-primary',
                                action: row => {
                                    showAssignPromoCodeModal(item)
                                },
                            },
                            {
                                text: item.active ? 'Deactivate':'Activate',
                                tooltip: `${item.active? 'Deactivate':'Activate'} Promo Code`,
                                class: 'btn btn-warning',
                                action: row => {
                                    const status = item.active? 'deactive':'active'
                                    onActiveStatus(item,status);
                                }
                            },
                            {
                                class: 'btn btn-success btn-circle glyphicon glyphicon-pencil',
                                tooltip:'Edit Promo Code',
                                action: row => {
                                    EditPromoCodeDetailsModal(item)
                                }
                            },
                            {
                                class: 'btn btn-danger btn-circle glyphicon glyphicon-trash',
                                tooltip:'Delete Promo Code',
                                action: row => {
                                    onDeleteBtnAccountClicked(item)
                                }
                            },

                        ]
                    };

                    if(!role){
                        item.actions.buttons.splice(1,2)
                    }

                    tableData.data.push(item);
                });
            };

            function onActiveStatus(item,status){
                if(status ==='deactive'){
                    statusConfirmationModal.getInstance().result.then(function(cond) {
                        if (!cond) { return; }
                        // add api call
                        AffiliateService.updateStatus(item.id,res=>{
                            toastr.success('Successfully deactivated!');
                            tableActions.sendRequest();
                        },
                        err=>{
                            toastr.error(err.message)
                        },status)
                    });
                    return;
                }

                // api call
                AffiliateService.updateStatus(item.id,res=>{
                    toastr.success('Successfully activated!');
                    tableActions.sendRequest();
                },
                err=>{
                    toastr.error(err.message)
                },status)

            }

            function durationFormat(item){
                let day = item.durationDay;
                let month =  item.durationMonth;
                let week = item.durationWeek;
                return month ? month+'Month(s)' : week ? week + 'Week(s)' : day + 'Day(s)';
            }
           
            this.tableData = tableData;
            this.refreshTable = refreshTable;

            function refreshTable(){
                tableActions.sendRequest();
            }

            function onDeleteBtnAccountClicked(item) {
                deleteConfirmationModal.getInstance().result.then(function(cond) {
                    if (!cond) { return; }
                    remove(item)
                });
            }

            function showPromoCodeDetailsModal(data) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/affiliateSales/modal/promoCode.html',
                    controller: 'PromoCodeController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        data: function () {
                            return angular.copy(data)
                        }
                    },

                });

                modalInstance.result.then(function (data) {
                    tableActions.sendRequest();
                }, function () {
                    tableActions.sendRequest();
                });
            };

            function EditPromoCodeDetailsModal(data) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/affiliateSales/modal/promoCode.html',
                    controller: 'EditPromoCodeController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        data: function () {
                            return angular.copy(data);
                        }
                    },

                });

                modalInstance.result.then(function (data) {
                    tableActions.sendRequest();
                });
            }; 

            function remove(data){
                AffiliateService.deletePromoCode(
                    res=>{
                        toastr.success('Successfully deleted!');
                        tableActions.sendRequest();
                    },
                    err=>{
                        toastr.error(err.message)
                    },data.id
                )
            }

            function showAssignPromoCodeModal(data) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/affiliateSales/modal/assignPromoCode.html',
                    controller: 'AssignPromoCodeContrller',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        data: function () {
                            return angular.copy(data)
                        }
                    },
                });

                modalInstance.result.then(function (data) {
                    tableActions.sendRequest();
                });

               
            };
        };
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/AffiliatePromoCodeTableService.js